import {BaseService} from './BaseService';
import {HtmlMailDAO} from '../DAO/HtmlMailDAO';
import {HtmlMailDTOInterface} from '../DTO/HtmlMailDTOInterface';

/**
 * HtmlMailService
 * HTMLメールサービス
 */
export class HtmlMailService extends BaseService {

	/**
	 * テンプレート一覧取得
	 */
	public async getList(): Promise<Array<HtmlMailDTOInterface>> {
		const dao = new HtmlMailDAO(this);
		const list = await dao.getList();
		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}
		return list;
	}

	/**
	 * 送信
	 * @param subject メール件名
	 * @param content HTML本文
	 * @param userIds 送信先ユーザーIDのカンマ区切り文字列
	 * @param sendLine LINE同時送信フラグ
	 */
	public async send(subject: string, content: string, userIds: string, sendLine: number): Promise<any> {
		const dao = new HtmlMailDAO(this);
		const result = await dao.send(subject, content, userIds, sendLine);
		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}
		return result;
	}
}